import Vue from "vue";
import Icon from "@/components/Elements/Icon";
import Btn from "@/components/Elements/Btn";
import Page from "@/components/Elements/Page";
import Section from "@/components/Elements/Section";
import Alert from "@/components/Elements/Alert";
import Loading from "@/components/Elements/Loading";

import "@/filters/truncate.ts";
import "@/filters/currency.ts";
import "@/filters/percent.ts";

Vue.config.productionTip = false;

Vue.component("Alert", Alert);
Vue.component("Page", Page);
Vue.component("Section", Section);
Vue.component("Icon", Icon);
Vue.component("Btn", Btn);
Vue.component("Loading", Loading);
